import { render, staticRenderFns } from "./SABWidgetGenerator.vue?vue&type=template&id=78f30b8d&scoped=true"
import script from "./SABWidgetGenerator.vue?vue&type=script&lang=js"
export * from "./SABWidgetGenerator.vue?vue&type=script&lang=js"
import style0 from "./SABWidgetGenerator.vue?vue&type=style&index=0&id=78f30b8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f30b8d",
  null
  
)

export default component.exports